import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Provider } from 'react-redux';

import ThemeProvider from '@synergycms_core/components/providers/themeProvider';
import PopoverProvider from '@synergycms_core/components/providers/popoverProvider';
import SlideProvider from '@synergycms_core/components/providers/slideProvider';
import App from './containers/app/App.jsx';
import store from '@synergycms_core/configureStore.js';
import actions from './store/actions'
import ContentProvider from '@synergycms_core/components/providers/translateProvider';
import EnvInfo from '@synergycms_core/components/generic/EnvInfo';



if (process.env.NODE_ENV === 'development') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: true,
  });
}

window.availVersion = process.env.APP_VERSION;
console.log(process.env.APP_VERSION);
console.log("app - "  , process.env.MAIN_BRANCH);
console.log("core - " , process.env.CORE_BRANCH);
const engineData =  (window.frontLoader && window.frontLoader['cms-avail']?.config) || window.engine_sygy_data || {};
Provider.displayName = "redux";

ReactDOM.render(
  <Provider store={store}>
    <ContentProvider value={{
      lang: (window.frontLoader && window.frontLoader.lang_info?.code ) || window.lang_info.code,
      theme: engineData.theme || window.synergyCmsAvailTheme,
      i18n: (window.frontLoader && window.frontLoader['cms-avail']?.i18n) || window.i18n,
      links: Object.assign(window.cmsLinks || {}, engineData.links),
      translationsActions : actions.translations,
      fontIcons: engineData.theme_values?.fontFamily3 || 'Icons'
    }}>
      <ThemeProvider value={{
        appId: "avail",
        theme: engineData.theme || window.synergyCmsAvailTheme,
        themeValues: engineData.theme_values || window.theme_values
      }}>
        <PopoverProvider>
          <SlideProvider>
            <EnvInfo/>
            <App />
          </SlideProvider>
        </PopoverProvider>
      </ThemeProvider>
    </ContentProvider>
  </Provider>,
  document.getElementById('root')
);
